export enum ContractContext {
    STUDIO_BOOKING_CONTRACT = 'STUDIO_BOOKING_CONTRACT',
    CLIENT_BOOKING_CONTRACT = 'CLIENT_BOOKING_CONTRACT',
    STUDIO_STANDALONE_CONTRACT = 'STUDIO_STANDALONE_CONTRACT',
    CLIENT_STANDALONE_CONTRACT = 'CLIENT_STANDALONE_CONTRACT'
}

export type ContractUser = 'studio' | 'primaryContact' | 'secondaryContact';
